import { useState } from "react";

interface ChatModalState {
  showChatModal: boolean;
  isTextOnlyMode: boolean;
  startedFromText: boolean;
}

export const useChatModalState = () => {
  const [chatState, setChatState] = useState<ChatModalState>({
    showChatModal: false,
    isTextOnlyMode: false,
    startedFromText: false,
  });

  const openChatModal = (startedFromText: boolean = false) => {
    setChatState({
      showChatModal: true,
      isTextOnlyMode: true,
      startedFromText,
    });
  };

  const closeChatModal = () => {
    setChatState({
      showChatModal: false,
      isTextOnlyMode: false,
      startedFromText: false,
    });
  };

  const setTextOnlyMode = (enabled: boolean) => {
    setChatState((prev) => ({
      ...prev,
      isTextOnlyMode: enabled,
    }));
  };

  return {
    ...chatState,
    openChatModal,
    closeChatModal,
    setTextOnlyMode,
  };
};
